import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🚀", key: "yes" },
  { emoji: "👀", key: "showMe" },
  { emoji: "💪", key: "almost" },
]

export default function LooksmaxxingReadyToTransformPage() {
  return (
    <RadioCardListPage
      translationKey="readyToTransformLooksmaxxing"
      options={OPTIONS}
      subtitle="subtitle"
    />
  )
}
